var map = {
	"./admins": "9203",
	"./admins.js": "9203",
	"./articles": "5e84",
	"./articles.js": "5e84",
	"./authors": "3993",
	"./authors.js": "3993",
	"./carousel": "0168",
	"./carousel.js": "0168",
	"./contactUs": "e759",
	"./contactUs.js": "e759",
	"./emails": "b879",
	"./emails.js": "b879",
	"./externalWebsiteLinks": "efa1",
	"./externalWebsiteLinks.js": "efa1",
	"./likes": "9ff6",
	"./likes.js": "9ff6",
	"./news": "611b",
	"./news.js": "611b",
	"./problems": "7956",
	"./problems.js": "7956",
	"./sections": "91cf",
	"./sections.js": "91cf",
	"./statistics": "100d",
	"./statistics.js": "100d",
	"./subSections": "5fbf",
	"./subSections.js": "5fbf",
	"./translators": "031e",
	"./translators.js": "031e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7905";